import { lazy, Suspense, useState } from "react";
import Head from "./Head";
import Office from "./components/questions";
import { About } from "./components/About";
import { Icons } from "./components/Icons";
import styled from "styled-components";
import { AccessibilityWidget } from "react-accessibility";
import CookieConsent from "./CookieConsent";
import { Helmet } from "react-helmet";
import { TopSection3 } from "./components/topSection3";
import { TopSection } from "./components/topSection";
import { Contact } from "./Sections/contact";
import WhatsAppBot from './WhatsAppBot';

import Adsense from "./Adsense";
import "./App.css";

const Home = lazy(() => import("./Pages/Home"));
const Header = lazy(() => import("./components/Header/index"));

const Styleapp = styled.div`
  width: 100%;
  min-height: 100vh;
  background: radial-gradient(circle at top, #081a2f, #081a2f);
`;

const AdsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  min-height: 0;
  height: auto;
  overflow: hidden;

  ins.adsbygoogle {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
    line-height: 0;
  }
`;

const seo = {
  title: "ניקיון משרדים מקצועי לעסקים | SG1 - חברת ניקיון ואחזקות בישראל",
  description:
    "SG1 מספקת שירותי ניקיון משרדים, אחזקת מבנים וניקיון לעסקים בכל רחבי ישראל. שירות מקצועי, אמינות גבוהה והתאמה מלאה לצרכי העסק שלך.",
  keywords:
    "ניקיון משרדים, חברת ניקיון, ניקיון לעסקים, אחזקת מבנים, ניקיון משרדים פתח תקווה, חברת ניקיון בישראל, שירותי ניקיון לעסקים",
  url: "https://sg1.co.il/",
  image: "https://sg1.co.il/logo192.png",

  // 🔥 תוספת מקצועית (לא חובה אבל חזק)
  siteName: "SG1 ניקיון ואחזקות",
  locale: "he_IL",
};
function App() {
  const [landingPageData] = useState({});

  return (
    <Styleapp>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href={seo.url} />

        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:url" content={seo.url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SG1 ניקיון משרדים ואחזקות" />
      </Helmet>

      <Suspense fallback={<div />}>
        <Icons />
          <WhatsAppBot />
        <AccessibilityWidget />
        <CookieConsent />


        <Header data={landingPageData.Features} />
        <Head data={landingPageData.Features} />
        <Office data={landingPageData.Features} />
        <Home data={landingPageData.Features} />
        <About data={landingPageData.Features} />
        <TopSection data={landingPageData.Features} />
        <TopSection3 data={landingPageData.Features} />
        <Contact data={landingPageData.Features} />

        {/* 🔥 חשוב: Adsense בסוף */}
        <AdsWrapper>
          <Adsense />
        </AdsWrapper>
      </Suspense>
    </Styleapp>
  );
}

export default App;